import { Card } from "semantic-ui-react";
import OldAssetsSelectionCard from "../OldAssetsSelectionCard/OldAssetsSelectionCard";

const UserAssets = (props) => {
  const { assets, handleSetClickedAssetId, t } = props;

  return (
    <Card.Group itemsPerRow={6}>
      {assets.map((asset, i) => (
        <OldAssetsSelectionCard
          key={i}
          t={t}
          asset={asset}
          handleSetClickedAssetId={handleSetClickedAssetId}
        />
      ))}
    </Card.Group>
  );
};

export default UserAssets;
